import { render, staticRenderFns } from "./courses.html?vue&type=template&id=09592e3d&scoped=true&external"
import script from "./Courses.vue?vue&type=script&lang=js"
export * from "./Courses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09592e3d",
  null
  
)

export default component.exports